// extracted by mini-css-extract-plugin
module.exports = {"content":"SupppliersInfoAPIButton_content__1M5t4","button":"SupppliersInfoAPIButton_button__PyuhE","PopConfirm":"SupppliersInfoAPIButton_PopConfirm__dzbZk"};